export default __webpack_public_path__ + "static/aamsLogo-29949f0451eb9c689fd43f2b2e287e11.png";